import { type ClassName, twx } from '@ctw/shared/utils/tailwind';
import type { ReactNode } from 'react';

export interface ButtonGroupProps {
  className?: ClassName;
  children: ReactNode;
}

export const ButtonGroup = ({ className, children }: ButtonGroupProps) => (
  <div
    className={twx(
      '[&>button]:-ml-[1px] rounded-md [&>button]:rounded-none first:[&>button]:ml-0 first:[&>button]:rounded-l-md last:[&>button]:rounded-r-md',
      className,
    )}
  >
    {children}
  </div>
);
